export default {
  403: {
    // img: 'https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg',
    title: '403',
    desc: 'Xin lỗi, bạn không có quyền truy cập trang này!'
  },
  404: {
    // img: 'https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg',
    title: '404',
    desc: 'Xin lỗi, trang bạn đang truy cập không tồn tại hoặc đang được phát triển!'
  },
  500: {
    // img: 'https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg',
    title: '500',
    desc: 'Xin lỗi, đã xảy ra lỗi trên máy chủ!'
  }
};
